<template>
    <rkm-modal
        ref="Modal"
        title="Observações"
    >
        <Form
            ref="Form"
            :originalEspecialidade="originalEspecialidade"
            :especialidade="especialidade"
            @save="close"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

// Mixins.
import { object } from '@/mixins'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalEspecialidade: null,
        especialidade: null,
    }),
    methods: {
        open(especialidade) {

            this.originalEspecialidade = especialidade
            this.especialidade = this.clone(especialidade)

            this.$refs.Modal.show()
        },
        close() {

            this.$refs.Modal.hide()
        }
    },
    mixins: [object],
}
</script>